import formatters from 'lib/formatters'

export const mapSubaccountToFormValues = (subaccount: Object): Object => {
  if (!subaccount) return {}

  const { asset, vehicle } = subaccount

  const insuranceService = asset?.services?.find((service) => service.service_type === 'insurance') || {}
  const homeInsuranceService = asset?.services?.find((service) => service.service_type === 'home_insurance') || {}
  const floodInsuranceService = asset?.services?.find((service) => service.service_type === 'flood_insurance') || {}

  return {
    beneficiary_name: subaccount.beneficiary_name || '',
    investment_type: subaccount.investment_type || '',
    statement_info: subaccount.statement_info || null,
    contact_info: subaccount.contact_info || null,
    street_1: asset?.street_1 || '',
    street_2: asset?.street_2 || '',
    city: asset?.city || '',
    state: asset?.state || '',
    zip: asset?.zip || '',
    purchase_date: asset?.purchase_date || vehicle?.purchase_date || '',
    home_insurance_provider: insuranceService?.provider || '',
    home_insurance_coverage_start: insuranceService?.coverage_start || '',
    home_insurance_coverage_end: insuranceService?.coverage_end || '',
    home_insurance_provider: homeInsuranceService?.provider || '',
    home_insurance_coverage_start: homeInsuranceService?.coverage_start || '',
    home_insurance_coverage_end: homeInsuranceService?.coverage_end || '',
    flood_insurance_provider: floodInsuranceService?.provider || '',
    flood_insurance_coverage_start: floodInsuranceService?.coverage_start || '',
    flood_insurance_coverage_end: floodInsuranceService?.coverage_end || '',
    make: vehicle?.make || '',
    model: vehicle?.model || '',
    year: vehicle?.year || '',
    trim: vehicle?.trim || '',
    vin: vehicle?.vin || '',
    mileage: vehicle?.mileage ?? '',
    purchase_amount: formatters.currency(String(vehicle?.purchase_amount || '')),
    primary_garage_street_1: vehicle?.primary_garage_street_1 || '',
    primary_garage_street_2: vehicle?.primary_garage_street_2 || '',
    primary_garage_city: vehicle?.primary_garage_city || '',
    primary_garage_state: vehicle?.primary_garage_state || '',
    primary_garage_zip: vehicle?.primary_garage_zip || '',
    lien_date: vehicle?.lien_date || '',
    lien_state: vehicle?.lien_state || '',
    lien_holder: vehicle?.lien_holder || '',
    lien_id: vehicle?.lien_id || '',
    status: subaccount?.status || '',
  }
}

export const filterEmptyValues = (values: Object): Object => {
  return Object.keys(values).reduce((acc, key) => {
    const value = values[key]
    if (value !== null && value !== undefined && value !== '') {
      acc[key] = value
    }
    return acc
  }, {})
}
